module.exports = __webpack_public_path__ + "media/styles/images/svg/checkbox-checked-teal-3be132ca48222c1fe55cb1c70314576e.svg";